<div class="ui-g">
  <div class="ui-g-12" style="position: relative">
    <div class="card card-w-title">
      <h1>Rate Cards</h1>
      <p-tabView>
        <p-tabPanel header="Standard">
          <p-accordion
            [multiple]="true"
            [class.rate-card-accordion]="true"
            *ngIf="isLoadedS; else loading"
          >
            <p-accordionTab header="Driven" [selected]="true">
              <rate-card-grid
                [datas]="griddataSD"
                (onChangeIsServiceOfferedChange)="changeIsServiceOffered($event)"
                [inclusivityTypes]="inclusivityTypes"
              ></rate-card-grid>
            </p-accordionTab>
            <p-accordionTab
              header="Transported"
              [selected]="true"
              [style]="{ 'margin-top': '20px' }"
            >
              <rate-card-grid
                [datas]="griddataST"
                (onChangeIsServiceOfferedChange)="changeIsServiceOffered($event)"
                [inclusivityTypes]="inclusivityTypes"
              ></rate-card-grid>
            </p-accordionTab>
            <p-accordionTab header="Recovery" [selected]="true" [style]="{ 'margin-top': '20px' }">
              <rate-card-grid
                [datas]="griddataSR"
                (onChangeIsServiceOfferedChange)="changeIsServiceOffered($event)"
                [inclusivityTypes]="inclusivityTypes"
              ></rate-card-grid>
            </p-accordionTab>
          </p-accordion>
        </p-tabPanel>
        <p-tabPanel header="Out Of Hours">
          <p-accordion
            [multiple]="true"
            [class.rate-card-accordion]="true"
            *ngIf="isLoadedO; else loading"
          >
            <p-accordionTab header="Driven" [selected]="true">
              <rate-card-grid
                [datas]="griddataOD"
                (onChangeIsServiceOfferedChange)="changeIsServiceOffered($event)"
                [inclusivityTypes]="inclusivityTypes"
              ></rate-card-grid>
            </p-accordionTab>
            <p-accordionTab header="Transported" [selected]="true">
              <rate-card-grid
                [datas]="griddataOT"
                (onChangeIsServiceOfferedChange)="changeIsServiceOffered($event)"
                [inclusivityTypes]="inclusivityTypes"
              ></rate-card-grid>
            </p-accordionTab>
            <p-accordionTab header="Recovery" [selected]="true">
              <rate-card-grid
                [datas]="griddataOR"
                (onChangeIsServiceOfferedChange)="changeIsServiceOffered($event)"
                [inclusivityTypes]="inclusivityTypes"
              ></rate-card-grid>
            </p-accordionTab>
          </p-accordion>
        </p-tabPanel>
        <p-tabPanel header="Urgent">
          <p-accordion
            [multiple]="true"
            [class.rate-card-accordion]="true"
            *ngIf="isLoadedU; else loading"
          >
            <p-accordionTab header="Driven" [selected]="true">
              <rate-card-grid
                [datas]="griddataUD"
                (onChangeIsServiceOfferedChange)="changeIsServiceOffered($event)"
                [inclusivityTypes]="inclusivityTypes"
              ></rate-card-grid>
            </p-accordionTab>
            <p-accordionTab header="Transported" [selected]="true">
              <rate-card-grid
                [datas]="griddataUT"
                (onChangeIsServiceOfferedChange)="changeIsServiceOffered($event)"
                [inclusivityTypes]="inclusivityTypes"
              ></rate-card-grid>
            </p-accordionTab>
            <p-accordionTab header="Recovery" [selected]="true">
              <rate-card-grid
                [datas]="griddataUR"
                (onChangeIsServiceOfferedChange)="changeIsServiceOffered($event)"
                [inclusivityTypes]="inclusivityTypes"
              ></rate-card-grid>
            </p-accordionTab>
          </p-accordion>
        </p-tabPanel>
      </p-tabView>
    </div>
    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="isBusy"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 20%"
        width="50"
        height="50"
        alt="load"
      />
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
